// Экран «Журнал факта» — десятый экран нового фронта (п.20, 2026-09-07).
// Последние 200 отметок факта по проекту: кто (и в какой роли — #9, 2026-09-12),
// когда и что изменил. «— очищено —» = факт снят вручную: слепок СБ3 для задачи не действует.
// «Передел» — отметка по работе факта (шаг 2, 2026-09-13), пусто — по задаче ГПР.
import { useCallback, useEffect, useState } from 'react';
import { call, p, type Data } from '../api';
import type { ShellCtx } from '../shell';
import { fmt } from '../util';

type Zapis = Data<'/api/projects/{pid}/fakt/log', 'get'>[number];

export function FaktLog({ ctx }: { ctx: ShellCtx }) {
  const [rows, setRows] = useState<Zapis[]>([]);

  const load = useCallback(async () => {
    const r = await call<Zapis[]>('get', p('/api/projects/{pid}/fakt/log', { pid: ctx.pid }));
    if (!r.ok) { ctx.onError?.(r.error.message); return; }
    setRows(r.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.pid, ctx.reloadToken]);
  useEffect(() => { void load(); }, [load]);

  return (
    <div>
      <div className="tbl" style={{ maxHeight: '78vh' }}>
        <table>
          <thead>
            <tr>
              <th>Когда</th><th>Кто</th><th>Корпус</th><th>Работа</th><th>Передел</th><th>Эт.</th>
              <th>Статус</th><th>Начало</th><th>Окончание</th><th>%</th><th>Комментарий</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((x, i) => (
              <tr key={i}>
                <td>{x.vremya}</td>
                <td>{x.kto}{x.rol ? <span className="muted"> · {x.rol}</span> : null}</td>
                <td>{x.korpus || ''}</td>
                <td>{x.rabota}</td>
                <td className="muted">{x.podrabota || ''}</td>
                <td className="num">{x.etazh}</td>
                <td>{x.status || (x.kommentarij && x.kommentarij.startsWith('[отметка') ? '' : '— очищено —')}</td>
                <td>{fmt(x.nachalo)}</td>
                <td>{fmt(x.okonchanie)}</td>
                <td className="num">{x.procent ?? ''}</td>
                <td style={{ textAlign: 'left' }}>{x.kommentarij || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}
